import React from "react";
import { RiMessage3Fill, RiCloseLine } from "react-icons/ri";

interface Props {
  isOpen: boolean;
  onClick: () => void;
}

const ChatFloatButton: React.FC<Props> = ({ isOpen, onClick }) => (
  <button
    onClick={onClick}
    aria-label={isOpen ? "Close chat assistant" : "Open chat assistant"}
    className={`w-16 h-16 rounded-full flex items-center justify-center shadow-2xl transition-all duration-500 ease-in-out hover:scale-105 active:scale-95 ${
      isOpen
        ? "bg-white text-[#090F21] rotate-[360deg]"
        : "bg-[#090F21] text-white"
    }`}
  >
    {isOpen ? (
      <RiCloseLine size={30} strokeWidth={0.5} />
    ) : (
      <div className="relative">
        <RiMessage3Fill size={30} />
        <span className="absolute -top-1 -right-1 flex h-4 w-4">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75" />
          <span className="relative inline-flex rounded-full h-4 w-4 bg-green-500 border-2 border-[#090F21]" />
        </span>
      </div>
    )}
  </button>
);

export default ChatFloatButton;
